import React, { useEffect, useState } from "react";
import { api } from "../utils/apiHelper";
import "../styles/AdminFarmers.css";

const AdminFarmers = () => {

  const [users, setUsers] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFarmers();
  }, []);

  const fetchFarmers = async () => {
    try {

      const response = await api("/admin/farmers", "GET");

      if (response?.success) {
        setUsers(response.data);
        console.log("What is missing?");
      } else {
        throw new Error(response?.message || "Failed to load farmer leads.");
      }

    } catch (err) {
      setError(err.message || "Error retrieving farmer leads.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="adminFarmers">Loading leads...</div>;
  }

  return (
    <div className="adminFarmers">

      <h1>Farmer Lead Submissions</h1>

      {error && <p className="error">{error}</p>}

      {users.length === 0 && <p>No submissions yet.</p>}

      {users.map((user) => (

        <div key={user._id} className="farmerUser">

          <h2>{user.name}</h2>
          <p>{user.email}</p>

          {user.farmer && user.farmer.map((entry, index) => (

            <div key={index} className="farmerCard">

              <h3>{entry.name}</h3>

              <p>
                <strong>Email:</strong> {entry.email}
              </p>

              <p>
                <strong>Message:</strong>
              </p>

              <p className="farmerMessage">
                {entry.message}
              </p>

            </div>

          ))}

        </div>

      ))}

    </div>
  );
};

export default AdminFarmers;